const isJapanVisitor = () => {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (tz === 'Asia/Tokyo') return true;

  const langs = navigator.languages || [navigator.language];
  return langs.some(l => /^ja(-JP)?$/i.test(l));
}

const formatDate = (iso, { locale = 'en-US', timeZone = 'UTC', twoDigitDay = true } = {}) => {
    const opts = {
        month: 'short',
        day: twoDigitDay ? '2-digit' : 'numeric',
        year: 'numeric',
        timeZone
    };
    const d = new Date(iso);
    const parts = new Intl.DateTimeFormat(locale, opts).formatToParts(d);
    const obj = Object.fromEntries(parts.filter(p => p.type !== 'literal').map(p => [p.type, p.value]));
    return `${obj.month} ${obj.day} ${obj.year}`;
}

const generateVariantTitle = (variantTitle) => {
  if ((variantTitle ?? '').toLowerCase().includes('xxsmall')) {
    return 'xxs';
  } else if ((variantTitle ?? '').toLowerCase().includes('xsmall')) {
    return 'xs';
  } else if ((variantTitle ?? '').toLowerCase().includes('small')) {
    return 's';
  } else if ((variantTitle ?? '').toLowerCase().includes('medium')) {
    return 'm';
  } else if ((variantTitle ?? '').toLowerCase().includes('xxlarge')) {
    return 'xxl';
  } else if ((variantTitle ?? '').toLowerCase().includes('xlarge')) {
    return 'xl';
  } else if ((variantTitle ?? '').toLowerCase().includes('large')) {
    return 'l';
  } else if ((variantTitle ?? '').toLowerCase().includes('one size')) {
    return 'os';
  } else {
    return variantTitle;
  }
}